"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNASSIGNED_SOURCE = exports.TAB_MIN_WIDTH = exports.TAB_MAX_WIDTH = exports.STREAM_EMBED_CODE = exports.SOURCE_TYPE_PROPS = exports.PHONE_WIDTH = exports.PHONE_MAX_WIDTH = exports.MID_SIZE_BREAKPOINT = exports.INTERACTIVE_STREAM_PROPS = exports.INTERACTIVE_STREAM = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _variables = require("./variables");
var INTERACTIVE_STREAM = exports.INTERACTIVE_STREAM = {
  isLive: false,
  archived: false,
  deleted: false,
  _id: '601d29896d6d360e56013647',
  shortId: 'kpwL1ya5rz',
  team: '5f59f6f6be24b33fd6bda4f3',
  event: '5f59f6fbbe24b33fd6bda4fe',
  title: 'Ogopa Deejays',
  description: 'Carlif Records',
  startOn: 1612515600000,
  endOn: 1612515600000,
  createdOn: 1612523913944,
  modifiedOn: 1612900551319,
  broadcasts: [],
  authentication: {
    type: 'none',
    password: ''
  },
  playbackUrl: 'https://studio-headless-test-assets.s3.amazonaws.com/5.mp4',
  ivsChannelName: 'IVS Channel Name',
  theme: {
    featuredImageUrl: 'https://i.pinimg.com/736x/9d/0e/95/9d0e95a207231b44c265a8fef32d7127.jpg'
  }
};
var STREAM_EMBED_CODE = exports.STREAM_EMBED_CODE = "\n    <iframe\n    src='//player.vimeo.com/video/22439234?title=0&byline=0'\n    width='853' height='479' frameborder='0'\n    webkitallowfullscreen\n    mozallowfullscreen\n    allowfullscreen>\n    </iframe>\n    ";
var INTERACTIVE_STREAM_PROPS = exports.INTERACTIVE_STREAM_PROPS = {
  isLive: _propTypes["default"].bool,
  archived: _propTypes["default"].bool,
  deleted: _propTypes["default"].bool,
  _id: _propTypes["default"].string,
  shortId: _propTypes["default"].string,
  team: _propTypes["default"].string,
  event: _propTypes["default"].string,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string,
  startOn: _propTypes["default"].number,
  endOn: _propTypes["default"].number,
  createdOn: _propTypes["default"].number,
  modifiedOn: _propTypes["default"].number,
  broadcasts: _propTypes["default"].array,
  authentication: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    password: _propTypes["default"].string
  }),
  playbackUrl: _propTypes["default"].string,
  ivsChannelName: _propTypes["default"].string
};
var SOURCE_TYPE_PROPS = exports.SOURCE_TYPE_PROPS = _propTypes["default"].oneOf([_variables.EMBED_SOURCE_TYPE, _variables.BROADCAST_SOURCE_TYPE]);
var PHONE_WIDTH = exports.PHONE_WIDTH = '480px';
var PHONE_MAX_WIDTH = exports.PHONE_MAX_WIDTH = '800px';
var TAB_MIN_WIDTH = exports.TAB_MIN_WIDTH = '481px';
var TAB_MAX_WIDTH = exports.TAB_MAX_WIDTH = '768px';
var MID_SIZE_BREAKPOINT = exports.MID_SIZE_BREAKPOINT = '640px';
var UNASSIGNED_SOURCE = exports.UNASSIGNED_SOURCE = 'Unassigned';